const wrapper = "_35sw1qg4409";
const media = "_35sm13bwv8h";

export { media, wrapper };
import "./_introduction.style.linaria.module.css";
//# sourceMappingURL=_introduction.style.js.map
